const routes={
    Home:"/governance",
    Governence:"/governance",
    Production:"/production",
    Chart:"/governance/chart",
    Onboarding:"/onboarding",
    CustomerService:"/customer-service",
    AuthenticationCallback:"/authentication/callback",
    SilentAuthenticationCallback:"/authentication/silent_callback",
    MasterDash:"/master_performance_dashboard"
};
export default routes;